import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'

import CheckboxesFilterSideModal from '../../../components/filter/CheckboxesFilterSideModal'
import SelectAllUsersLink from '../SelectAllUsersLink'
import UsersLoader, { useUsers } from '../_load/UsersLoader'

const UsersFilterSideModal = ({ field, label, onClose, ...props }) => {
  field = field || 'userIds'
  label = label || 'Usuário'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <CheckboxesFilterSideModal
      label={label}
      value={value}
      dataHook={useUsers}
      onClose={v => {
        handleChange(field, v)
        onClose()
      }}
      Loader={UsersLoader}
      useSearch
      renderHeaderRightContent={params => <SelectAllUsersLink {...params} />}
      {...props}
    />
  )
}

export default UsersFilterSideModal
